/*
  Product information v2 template: mount Essential Upsell PRODUCT_ADDON
  (Garantieverlängerung) into the section app block placed after the review.
*/
(function () {
  var ROOT = '.product-info--v2';
  var MOUNT =
    '[id*="essential_upsell_app_block_addon"], [data-betunes-addon-mount]';
  var ADDON =
    '.essential-upsell-addon-container, [data-essential-upsell-funnel-content-offer-type="PRODUCT_ADDON"]';
  var TIMEOUT_MS = 20000;

  function closestMountable(node) {
    if (!node) return null;
    var host = node.closest(
      '.essential-upsell-addon-container, [data-essential-upsell-funnel-content-offer-type="PRODUCT_ADDON"]'
    );
    if (host) return host;

    var current = node;
    for (var i = 0; i < 6 && current && current.parentElement; i++) {
      var parent = current.parentElement;
      var text = (parent.innerText || '').slice(0, 120);
      if (/Garantieverl/i.test(text) && parent.children.length <= 8) {
        return parent;
      }
      current = parent;
    }
    return node;
  }

  function place(root) {
    var mount = root.querySelector(MOUNT);
    var addonNode = document.querySelector(ADDON);
    if (!mount || !addonNode) return false;

    var addon = closestMountable(addonNode);
    if (!addon || mount.contains(addon)) return true;

    mount.appendChild(addon);
    mount.setAttribute('data-betunes-addon-mounted', '1');
    return true;
  }

  function init() {
    var root = document.querySelector(ROOT);
    if (!root || !window.MutationObserver) return;
    if (place(root)) return;

    var observer = new MutationObserver(function () {
      if (place(root)) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, TIMEOUT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
